import { infoApi as base } from './base';
import { infoApi as AT } from './AT';
import { infoApi as CZ } from './CZ';
import { infoApi as SK } from './SK';
import { infoApi as RO } from './RO';
import { infoApi as HU } from './HU';
import { infoApi as HR } from './HR';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    SK,
    RO,
    HU,
    HR,
};
